import { useState } from 'react';

/**
 * Hook for form state management
 */
export const useFormState = <T extends Record<string, unknown>>(initialState: T) => {
  const [formData, setFormData] = useState<T>(initialState);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const handleInputChange = (
    e:
      | React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
      | { target: { name: string; value: unknown } }
  ): void => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const resetForm = (): void => {
    setFormData(initialState);
  };

  return {
    formData,
    setFormData,
    loading,
    setLoading,
    error,
    setError,
    handleInputChange,
    resetForm,
  };
};
